import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

export const Wrapp = styled("div")(() => ({
  width: 368,
  display: "flex",
  flexDirection: "column",
  gap: 32,
}))

export const Title = styled("div")(() => ({
  fontWeight: 600,
  lineHeight: "20px",
  textAlign: "center",
}))

export const Label = styled("div")(() => ({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: "20px",
  marginBottom: 8,
}))

export const BtnsBlock = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  gap: 12,
}))

export const Info = styled("div")(() => ({
  padding: 16,
  borderRadius: 8,
  background: palette.grey25,
  display: "flex",
  gap: 16,
  justifyContent: "space-between",
  marginTop: 16,

  svg: {
    minWidth: 20,
  },
}))

export const InfoText = styled("div")(() => ({
  fontSize: 13,
  lineHeight: "16px",
  color: "#676F71",
}))
